module.exports = __webpack_public_path__ + "static/media/angularjs.1091f88a.png";